import { financeContext } from '../services/financeScope';
import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_API_URL;
axios.defaults.withCredentials = true;

const token = localStorage.getItem('auth_token');
if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}

axios.interceptors.request.use((config) => {
    const currentToken = localStorage.getItem('auth_token');
    if (config.authTokenSnapshot && config.authTokenSnapshot !== currentToken) {
        throw new axios.CanceledError('O perfil autenticado mudou.');
    }
    if (currentToken) {
        config.headers.Authorization = `Bearer ${currentToken}`;
    }

    const isFinance = /\/api\/finance(?:\/|$)/.test(config.url || '');
    if (isFinance) {
        config.financeRevision = financeContext.revision;
        const isGoal = /\/goals(?:\/|$)/.test(config.url);
        if (isGoal) {
            config.params = { ...config.params, scope: financeContext.goals };
            if (config.data && typeof config.data === 'object') config.data = { ...config.data, scope: financeContext.goals };
        } else if ((config.method || 'get').toLowerCase() === 'get') {
            config.params = { ...config.params, scope: financeContext.scope };
        }
    }
    return config;
});

axios.interceptors.response.use(response => {
    if (response.config.financeRevision !== undefined && response.config.financeRevision !== financeContext.revision) {
        return Promise.reject(new axios.CanceledError('A visão financeira mudou.'));
    }
    return response;
}, error => {
    if (error.response?.status === 403 && error.config?.params?.scope && error.config.params.scope !== 'self') {
        window.dispatchEvent(new CustomEvent('couple-access-revoked'));
    }
    return Promise.reject(error);
});

export default {
    axios
}
